export class CreateCoursesFromLevel {
    newLevelId: string;
    prevLevelId: string;
    letters: string;
    includeStudents: boolean;
}